import {
  SECTIONS,
  NOTIFICATION_TYPES,
  OPERATIONS,
} from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import {
  Alert,
  Button,
  Checkbox,
  Drawer,
  Dropdown,
  Form,
  Input,
  Menu,
  MenuProps,
  Radio,
  RadioChangeEvent,
  Select,
  Space,
  Tabs,
} from "antd";
import "./LegacyMapping.css";
import Mapping, { TableDataType } from "./components/Mapping";
import MappingTemplate from "./components/MappingTemplate";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import {
  CloseOutlined,
  UndoOutlined,
  SwapOutlined,
  FlagOutlined,
  NodeExpandOutlined,
  CheckOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { GetTablesRequest } from "../../../../models/tables/GetTablesRequest";
import { GetFieldMappingsRequest } from "../../../../models/fieldmappings/GetFieldMappingsRequest";
import FieldMappingsService from "../../../../services/fieldmappings/FieldMappingsService";
import TableFieldsService from "../../../../services/tablefields/TableFieldsService";
import MappingTemplateService from "../../../../services/mappingtemplates/MappingTemplatesService";
import styles from "./LegacyMapping.module.css";
import { CreateMappingTemplate } from "../../../../models/mappingtemplates/CreateMappingTemplate";
import { CreateMappingTemplateMapping } from "../../../../models/mappingtemplates/CreateMappingTemplateMapping";
import { useTranslation } from "react-i18next";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import history from "../../../shared/utils/HistoryUtil";
import { ROUTES } from "../../../../config/consts/routes";
import { GetFieldsRequest } from "../../../../models/fields/GetFieldsRequest";
import { System } from "../../../../models/system/System";
import SystemService from "../../../../services/sytem/SystemService";
import { FieldMappingRequest } from "../../../../models/ai-auto-mapping/FieldMappingRequest";
import AiFieldMappingService from "../../../../services/ai-hub/AiFieldMappingService";
import { Table } from "../../../../models/tables/Table";

const { TabPane } = Tabs;
const { Search } = Input;

const routes = [
  {
    path: ROUTES.general.main.name,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.operation.name,
  },
  {
    path: ROUTES.operation.legacyMapping.route,
    breadcrumbName: ROUTES.operation.legacyMapping.name,
  },
];

const LegacyMapping = () => {
  const { t, i18n } = useTranslation("translations");
  const [searchParams, setSearchParams] = useSearchParams();

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [sourceTables, setSourceTables] = useState<Table[]>([]);
  const [sourceTableFields, setSourceTableFields] = useState<any>([]);
  const [unmappedFields, setUnmappedFields] = useState<any>([]);
  const [fieldMappings, setFieldMappings] = useState<any>([]);
  const [editableFieldMappings, setEditableFieldMappings] = useState<TableDataType[]>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [mappingTemplates, setMappingTemplates] = useState<any>([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [newMappingTemplateName, setNewMappingTemplateName] =
    useState<string>("");
  const [existingMappingTemplate, setSelectedExistingMappingTemplate] =
    useState<number>();
  const [
    existingMappingTemplateSearchInput,
    setExistingMappingTemplateSearchInput,
  ] = useState<string>("");
  const [selectedApplyMappingTemplate, setSelectedApplyMappingTemplate] =
    useState<number>();
  const [applyMappingTemplateSearchInput, setApplyMappingTemplateSearchInput] =
    useState<string>("");

  const [visibleDrawer, setVisibleDrawer] = useState("0");
  const [mappingTemplateType, setMappingTemplateType] = useState(1);

  const [saveMappingTemplateLoading, setSaveMappingTemplateLoading] =
    useState(false);

  const [isDirty, setIsDirty] = useState<any>(false);
  const [currentActiveKey, setCurrentActiveKey] = useState<any>(
    searchParams.get("tab")
  );

  useEffect(() => {
    const difference = fieldMappings.filter(({ id: id1, fromFieldId: fromFieldId1 }) => !editableFieldMappings
      .some(({ id: id2, fromFieldId: fromFieldId2 }) => id2 === id1 && fromFieldId1 === fromFieldId2))
    difference.length
      ? setIsDirty(true)
      : setIsDirty(false);
  }, [editableFieldMappings]);

  const [unfinishedMappingSourceTable, setUnfinishedMappingSourceTable] = useState<any>(undefined);

  const { state }: any = useLocation();
  const [transferedState, setTransferedState] = useState(null);

  //#region Automap with AI
  const [isVisibleAutomapWithAiDrawer, setIsVisibleAutomapWithAiDrawer] = useState(false);

  const [entitySystems, setEntitySystems] = useState<System[]>([]);

  const [selectedSourceTable, setSelectedSourceTable] = useState<Table>();
  const [selectedDestinationTable, setSelectedDestinationTable] = useState<Table>();

  const [isAiEnabled, setIsAiEnabled] = useState(false);

  useEffect(() => {
    // Fetch all systems to populate the dropdown for source and destination ERP selection
    SystemService.getAll()
      .then((res) => {
        setEntitySystems(res.data);
      });

    AiFieldMappingService.isAiEnabled().then((response) => {
      setIsAiEnabled(response.data);
    })
  }, []);

  const [AutomapWithAiForm] = Form.useForm<FieldMappingRequest>();

  const onOpenAutoMapAiDrawer = () => {
    setIsVisibleAutomapWithAiDrawer(true);
    AutomapWithAiForm.setFieldsValue({
      fromTableId: selectedSourceTable.id,
      toTableId: selectedDestinationTable.id,
      sourceErpId: selectedSourceTable.systemId,
      targetErpId: selectedDestinationTable.systemId,
      groupCode: selectedGroupCode,
      entityId: selectedEntity,
      useDescription: true,
      useAiDescription: true,
      useSampleData: true,
    })
  }

  const onAutoMapAiClick = () => {
    setIsVisibleAutomapWithAiDrawer(false);
    setIsTableLoading(true);

    const request: FieldMappingRequest = AutomapWithAiForm.getFieldsValue();
    AiFieldMappingService.automap(request)
      .then((response) => {
        applyFieldName(response.data);
        const data = response.data;
        if (data) {
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.AutomapSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "Automap successfully executed.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
        } else {
          NotificationsUtil.openNotificationDialog({
            description: t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.AutomapNoResultsDescription",
              {
                lngs: i18n.languages,
                defaultValue: "No results found.",
              }
            )!,
            type: NOTIFICATION_TYPES.INFO,
            logError: false,
          });
        }
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      })
      .finally(() => {
        AutomapWithAiForm.resetFields()
        setIsTableLoading(false);
      });
  }

  const applyFieldName = (mappingDictionary: Record<string, string>) => {
    const newEditableFieldMappings = editableFieldMappings.map((mapping) => {
      const fromFieldName = mappingDictionary[mapping.toField];
      if (fromFieldName) {

        const match = unmappedFields.find(
          (f: any) => f.name.toLowerCase() === fromFieldName.toLowerCase()
        );
        if (match) {
          return {
            ...mapping,
            comments: "AI assisted mapping",
            fromFieldId: match.id,
            fromField: match.name,
            fromTableFields: [match],
            fromValue: "",
            isAiField: true,
          };
        }
      }
      return mapping;
    });
    setEditableFieldMappings(newEditableFieldMappings);
  };

  //#endregion

  useEffect(() => {
    if (transferedState) {
      setUnfinishedMappingSourceTable(transferedState.sourceTable);
    }
  }, [transferedState]);

  useEffect(() => {
    if (searchParams.get("sourceTable")) {
      setTransferedState({ sourceTable: searchParams.get("sourceTable") })
    }
  }, [searchParams])

  useEffect(() => {
    if (state) {
      setTransferedState(state);
    }
  }, [state]);

  useEffect(() => {
    document.title = ROUTES.operation.legacyMapping.name;
  }, []);

  useEffect(() => {
    if (!isDirty) return;

    const unblock = history.block((tx: any) => {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        unblock();
        tx.retry();
      }
    });

    return () => {
      unblock();
    };
  }, [isDirty]);

  useEffect(() => {
    if (!isDirty && currentActiveKey) {
      onChange(currentActiveKey);
    }
  }, [isDirty, currentActiveKey]);

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
    MappingTemplateService.getAll().then((response: any) => {
      const data = response.data;
      setMappingTemplates(data);
    });
  }, []);

  useEffect(() => {
    if (operations) {
      setSelectedOperation(OPERATIONS.LEGACY)
    }
  }, [operations]);

  useEffect(() => {
    setSelectedSourceTable(null);
    if (selectedGroupCode && selectedEntity) {
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        operationId: 1,
        groupCode: selectedGroupCode,
      };

      TablesService.getTables(model).then((response: any) => {
        const data = response.data;
        setSourceTables(data);
      });
    }
  }, [selectedGroupCode, selectedEntity, transferedState]);

  useEffect(() => {
    if (unfinishedMappingSourceTable && sourceTables.length > 0) {
      setSelectedSourceTable(sourceTables.find((x: any) => x.name === unfinishedMappingSourceTable));
    }
  }, [unfinishedMappingSourceTable, sourceTables])

  useEffect(() => {
    if (selectedEntity) {
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        operationId: 2,
        groupCode: "",
      };
      TablesService.getTables(model).then((response) => {
        const data = response.data;
        if (data && data !== undefined && data.length > 0) {
          setSelectedDestinationTable(data[0]);
        } else {
          setIsTableLoading(false);
        }
      });
    }
  }, [selectedEntity]);

  useEffect(() => {
    if (selectedSourceTable) {
      TableFieldsService.getAllFrom(selectedSourceTable.id).then(
        (response: any) => {
          const data = response.data;
          setSourceTableFields(data);
        }
      );
    } else {
      setSourceTableFields([]);
    }
  }, [selectedSourceTable, triggerUpdate]);

  useEffect(() => {
    if (sourceTableFields && fieldMappings) {
      setUnmappedFields(sourceTableFields);
    }
  }, [sourceTableFields, fieldMappings, triggerUpdate]);

  useEffect(() => { }, [unmappedFields]);

  useEffect(() => {
    if (selectedGroupCode && selectedSourceTable && selectedDestinationTable) {
      const model: GetFieldMappingsRequest = {
        groupCode: selectedGroupCode,
        fromTableId: selectedSourceTable.id,
        toTableId: selectedDestinationTable.id,
      };
      const fieldsModel: GetFieldsRequest = {
        tableId: selectedDestinationTable.id
      };

      TablesService.getFields(fieldsModel).then((fieldsResponse) => {
        FieldMappingsService.getAll(model).then((response: any) => {
          const data = response.data;
          setFieldMappings(
            data.map((x: any) => ({
              ...x,
              fromValue: x.fromValue === null ? "" : x.fromValue,
              comments: x.comments === null ? "" : x.comments,
              fromField: x.fromField === null ? "" : x.fromField,
              isSystemField: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.isSystemField,
              mandatory: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.isMandatory,
              label: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.label,
              description: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.description,
              fromTableFields:
                x.fromFieldId != null
                  ? [
                    {
                      fromFieldId: x.fromFieldId,
                      fromField: x.fromField,
                      tableId: x.fromTableId,
                    },
                  ]
                  : [],
            }))
          );
          setIsTableLoading(false);
        });
      });
    } else {
      setIsTableLoading(false);
    }
  }, [
    selectedGroupCode,
    selectedSourceTable,
    selectedDestinationTable,
    triggerUpdate,
  ]);

  const onChange = (key: string) => {
    if (isDirty) {
      if (
        window.confirm(
          "Are you sure you want leave the page without saving? Current changes will be lost."
        )
      ) {
        setIsDirty(false);
        onReset();
        setCurrentActiveKey(key);
      }
    } else {
      searchParams.set("tab", key);
      setSearchParams(searchParams);
      setCurrentActiveKey(key);
    }
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    showDrawer(e.key);
    try {
      if (e.key === "3") {
        automap();
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.AutomapSuccessDescription",
            {
              lngs: i18n.languages,
              defaultValue: "Automap successfully executed.",
            }
          )!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
        setSaveMappingTemplateLoading(false);
      }
    } catch (error: any) {
      NotificationsUtil.openNotificationDialog({
        description: error.response.data,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setSaveMappingTemplateLoading(false);
    }
  };

  const dropdownMenu = (
    <Menu
      className="twoFoldMenu"
      style={{ padding: "10px" }}
      selectable
      onClick={handleMenuClick}
      items={
        [
          {
            label: t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionSaveAsTemplate",
              {
                lngs: i18n.languages,
                defaultValue: "Save as template",
              }
            ),
            key: "1",
            icon: <FlagOutlined />,
          },
          {
            label: t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionApplyTemplate",
              {
                lngs: i18n.languages,
                defaultValue: "Apply template",
              }
            ),
            key: "2",
            icon: <SwapOutlined />,
          },
          {
            label: t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionAutomap",
              {
                lngs: i18n.languages,
                defaultValue: "Automap",
              }
            ),
            key: "3",
            icon: <UndoOutlined />,
          },
        ]
      }
    />
  );

  const showDrawer = (key: string) => {
    setVisibleDrawer(key);
  };

  const onClose = () => {
    setVisibleDrawer("0");
  };

  const onCloseAutomapWithAiDrawer = () => {
    AutomapWithAiForm.resetFields();
    setIsVisibleAutomapWithAiDrawer(false);
  }

  const onRadioChange = (e: RadioChangeEvent) => {
    setMappingTemplateType(e.target.value);
  };

  const onMappingTemplateNameChange = (value: string) => {
    setNewMappingTemplateName(value);
  };

  const onReset = () => {
    setEditableFieldMappings(fieldMappings);
    setTriggerUpdate(!triggerUpdate);
  };

  const onSaveClick = () => {
    setIsSaveDisabled(true);
    const models = editableFieldMappings.map((element: any) => ({
      id: element.id,
      fromTableId:
        element.fromTableId != null
          ? element.fromTableId
          : selectedSourceTable.id,
      fromFieldId: element.fromFieldId,
      fromValue:
        element.fromFieldId != null ? element.fromField : element.fromValue,
      toTableId: element.toTableId,
      toFieldId: element.toFieldId,
      comments: element.comments,
    }));

    FieldMappingsService.bulkUpdate(models)
      .then((response: any) => {
        // setTriggerUpdate(true);
        setIsTableLoading(true);
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.SaveSuccessDescription",
            {
              lngs: i18n.languages,
              defaultValue: "Mappings successfully saved.",
            }
          )!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });

        const model: GetFieldMappingsRequest = {
          groupCode: selectedGroupCode,
          fromTableId: selectedSourceTable.id,
          toTableId: selectedDestinationTable.id,
        };

        const fieldsModel: GetFieldsRequest = {
          tableId: selectedDestinationTable.id
        };

        TablesService.getFields(fieldsModel).then((fieldsResponse) => {
          FieldMappingsService.getAll(model)
            .then((response: any) => {
              const data = response.data;
              setFieldMappings(
                data.map((x: any) => ({
                  ...x,
                  fromValue: x.fromValue === null ? "" : x.fromValue,
                  comments: x.comments === null ? "" : x.comments,
                  fromField: x.fromField === null ? "" : x.fromField,
                  isSystemField: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.isSystemField,
                  mandatory: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.isMandatory,
                  label: fieldsResponse.data?.find((y: any) => y.id === x.toFieldId)?.label,
                  fromTableFields:
                    x.fromFieldId != null
                      ? [
                        {
                          fromFieldId: x.fromFieldId,
                          fromField: x.fromField,
                          tableId: x.fromTableId,
                        },
                      ]
                      : [],
                }))
              );
              setIsTableLoading(false);
              setIsSaveDisabled(false);
            })
            .catch((error: any) => {
              setIsTableLoading(false);
              setIsSaveDisabled(false);
              NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
              });
            });
        })
          .catch((error: any) => {
            setIsTableLoading(false);
            setIsSaveDisabled(false);
            NotificationsUtil.openNotificationDialog({
              description: error.response.data,
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          });
      }).catch((error: any) => {
        setIsTableLoading(false);
        setIsSaveDisabled(false);
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });

  };

  const automap = () => {
    let newFieldMappings = editableFieldMappings.map((x: any) => x);
    let newUnmappedFields = unmappedFields.map((x: any) => x);
    try {
      for (let i = 0; i < newFieldMappings.length; i += 1) {
        if (
          newFieldMappings[i].fromFieldId === null &&
          (newFieldMappings[i].fromValue === null ||
            newFieldMappings[i].fromValue.length === 0)
        ) {
          const unmapped = newUnmappedFields;
          const fields = newUnmappedFields.filter(
            (el: any) =>
              el?.name?.toLowerCase() ===
              newFieldMappings[i]?.toField?.toLowerCase()
          );
          if (fields && fields.length === 1) {
            newFieldMappings[i].fromFieldId = fields[0].id;
            newFieldMappings[i].fromField = fields[0].name;
            newFieldMappings[i].fromTableFields = fields.splice(0, 1);
          }

          newUnmappedFields = unmapped.filter(
            (el: any) => el.id !== newFieldMappings[i].fromFieldId
          );

          setEditableFieldMappings(newFieldMappings);
          setUnmappedFields(newUnmappedFields);
          setSaveMappingTemplateLoading(false);
        }
      }
    } catch (error: any) {
      NotificationsUtil.openNotificationDialog({
        description: error.response.data,
        type: NOTIFICATION_TYPES.ERROR,
        logError: true,
      });
      setSaveMappingTemplateLoading(false);
    }
  };

  const saveMappingTemplate = () => {
    setSaveMappingTemplateLoading(true);
    // this.loading = true;
    const mappedRows = fieldMappings.filter(
      (el: any) => el.fromFieldId != null || el.fromValue.length
    );

    if (mappingTemplateType === 1) {
      // new template
      const model: CreateMappingTemplate = {
        tableID: selectedDestinationTable.id,
        name: newMappingTemplateName,
      };
      MappingTemplateService.create(model)
        .then((templateCreateResponse: any) => {
          MappingTemplateService.getAll().then((templateGetResponse: any) => {
            const data = templateGetResponse.data;
            setMappingTemplates(data);

            const rowsModel: CreateMappingTemplateMapping[] = fieldMappings
              .filter((x: any) => x.fromFieldId != null || x.fromValue)
              .map((element: any) => ({
                fromValue:
                  element.fromFieldId != null
                    ? element.fromField
                    : element.fromValue,
                toTableId: element.toTableId,
                toFieldId: element.toFieldId,
                link: element.link,
                comments: element.comments,
                templateId: templateCreateResponse.data,
              }));

            MappingTemplateService.createMappingsBulk(rowsModel).then(
              (bulkCreateResponse) => {
                NotificationsUtil.openNotificationDialog({
                  description: t(
                    "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.CreateSuccessDescription",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Mapping Template successfully created.",
                    }
                  )!,
                  type: NOTIFICATION_TYPES.SUCCESS,
                  logError: false,
                });
              }
            );
          });
        })
        .catch((error: any) => {
          NotificationsUtil.openNotificationDialog({
            description: error?.response?.data || "An error occurred.",
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        })
        .finally(() => {
          setSaveMappingTemplateLoading(false);
          setVisibleDrawer("0");
        });
    } else {
      // existing template
      if (existingMappingTemplate) {
        const rowsModel = mappedRows.map((element: any) => ({
          fromValue:
            element.fromFieldId != null ? element.fromField : element.fromValue,
          toTableId: element.toTableId,
          toFieldId: element.toFieldId,
          link: element.link,
          comments: element.comments,
          templateId: existingMappingTemplate,
        }));

        MappingTemplateService.removeAllMappings(existingMappingTemplate).then(
          (response: any) => {
            MappingTemplateService.createMappingsBulk(rowsModel)
              .then((bulkCreateResponse) => {
                NotificationsUtil.openNotificationDialog({
                  description: t(
                    "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.UpdateSuccessDescription",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Mapping Template successfully updated.",
                    }
                  )!,
                  type: NOTIFICATION_TYPES.SUCCESS,
                  logError: false,
                });
              })
              .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                  description: error.response.data,
                  type: NOTIFICATION_TYPES.ERROR,
                  logError: true,
                });
                setSaveMappingTemplateLoading(false);
              }).finally(() => {
                setSaveMappingTemplateLoading(false);
                setVisibleDrawer("0");
              });
          }
        );
      } else {
        setSaveMappingTemplateLoading(false);
      }
    }
  };

  const applyTemplate = () => {
    // this.loading = true;
    if (!selectedApplyMappingTemplate) {
      return;
    }

    MappingTemplateService.getAllMappings(selectedApplyMappingTemplate)
      .then((response) => {
        const newEditableFieldMappings = editableFieldMappings.map(
          (x: any) => x
        );

        let unmapped = unmappedFields.map((x: any) => x);
        for (let i = 0; i < response.data.length; i += 1) {
          let rowIndex = -1;
          const fields = newEditableFieldMappings.filter(
            (el: any) => el.toFieldId === response.data[i].toFieldId
          );
          if (fields && fields.length === 1) {
            rowIndex = newEditableFieldMappings.indexOf(fields[0]);
          }
          if (rowIndex !== -1) {
            newEditableFieldMappings[rowIndex].fromValue =
              response.data[i].fromValue;
            const fields = unmapped.filter(
              (el: any) =>
                el.name.toLowerCase() ===
                newEditableFieldMappings[rowIndex].fromValue.toLowerCase()
            );
            if (fields.length === 1) {
              newEditableFieldMappings[rowIndex].fromFieldId = fields[0].id;
              newEditableFieldMappings[rowIndex].fromField = fields[0].name;
              newEditableFieldMappings[rowIndex].fromTableFields =
                fields.splice(0, 1);
              newEditableFieldMappings[rowIndex].fromValue = "";
            }
            unmapped = unmapped.filter(
              (el: any) =>
                el.id !== newEditableFieldMappings[rowIndex].fromFieldId
            );
            setUnmappedFields([...unmapped]);
          }
        }
        setEditableFieldMappings(newEditableFieldMappings);
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Operation.LegacyMapping.Tabs.Mapping.Notifications.Mapping.AppliedSuccessDescription",
            {
              lngs: i18n.languages,
              defaultValue: "Template successfully applied.",
            }
          )!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
        setSaveMappingTemplateLoading(false);
      });
  };

  const handleExistingMappingTemplateChange: MenuProps["onClick"] = (e) => {
    // setIsTableLoading(true);
    setSelectedExistingMappingTemplate(parseInt(e.key, 10));
  };

  const handleApplyMappingTemplateChange: MenuProps["onClick"] = (e) => {
    // setIsTableLoading(true);
    setSelectedApplyMappingTemplate(parseInt(e.key, 10));
  };

  const onExistingMappingTemplateSearch = (value: string) => {
    setExistingMappingTemplateSearchInput(value);
  };

  const onApplyMappingTemplateSearch = (value: string) => {
    setApplyMappingTemplateSearchInput(value);
  };

  const actionButton = (
    <>
      <Button
        style={{ marginRight: "0.1px" }}
        className="automap-button"
        icon={<img src="/ai.svg" />}
        onClick={onOpenAutoMapAiDrawer}
        disabled={!isAiEnabled || !selectedEntity || !selectedGroupCode || !selectedSourceTable}
        type={
          !isAiEnabled || !selectedEntity || !selectedGroupCode || !selectedSourceTable
            ? "default"
            : "primary"
        }
      >
        {t("Page.Operation.LegacyMapping.Tabs.Mapping.Labels.AutomapWithAi", {
          lngs: i18n.languages,
          defaultValue: "Automap with AI",
        })}
      </Button>
      <Button
        disabled={!selectedEntity || !selectedGroupCode || !selectedSourceTable}
        loading={isSaveDisabled}
        type={
          !selectedEntity || !selectedGroupCode || !selectedSourceTable
            ? "default"
            : "primary"
        }
        onClick={onReset}
        style={{ marginRight: "0.1px" }}
      >
        {!isSaveDisabled && <CloseOutlined />}
        {t("Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionReset", {
          lngs: i18n.languages,
          defaultValue: "Reset",
        })}
      </Button>
      <Dropdown.Button
        disabled={!selectedEntity || !selectedGroupCode || !selectedSourceTable}
        loading={isSaveDisabled}
        type={
          !selectedEntity || !selectedGroupCode || !selectedSourceTable
            ? "default"
            : "primary"
        }
        onClick={onSaveClick}
        overlay={dropdownMenu}
        style={{ borderColor: "var(--white)!important" }}
        placement="bottomRight"
        // arrow={DropdownArrowOptions.}
        trigger={["click"]}
        icon={<DownOutlined />}
      >
        {!isSaveDisabled && <CheckOutlined />}
        {t("Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionSave", {
          lngs: i18n.languages,
          defaultValue: "Save",
        })}
      </Dropdown.Button>
    </>
  );

  return (
    <div>
      <PageHead
        title={ROUTES.operation.legacyMapping.name}
        icon={<NodeExpandOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={
          searchParams.get("tab")
            ? searchParams.get("tab") === "mapping"
              ? false
              : searchParams.get("tab") === "mapping-templates"
                ? true
                : false
            : false
        }
        setSelectEntityDisabled={
          searchParams.get("tab")
            ? searchParams.get("tab") === "mapping"
              ? false
              : searchParams.get("tab") === "mapping-templates"
                ? true
                : false
            : false
        }
        setSelectOperationDisabled={true}
        mainAction={
          searchParams.get("tab")
            ? searchParams.get("tab") === "mapping"
              ? actionButton
              : searchParams.get("tab") === "mapping-templates"
                ? undefined
                : undefined
            : undefined
        }
        otherActions={[]}
        setActionsDisabled={false}
        showEntityCounts={true}
      />
      <div className="card-container">
        <Tabs
          type="card"
          activeKey={searchParams.get("tab") ? searchParams.get("tab")! : ""}
          onTabClick={onChange}
          style={{ height: "100%" }}
        >
          <TabPane
            tab={t("Page.Operation.LegacyMapping.Tabs.Mapping", {
              lngs: i18n.languages,
              defaultValue: "Mapping",
            })}
            key="mapping"
          >
            <DndProvider backend={HTML5Backend}>
              <Mapping
                selectedEntity={selectedEntity}
                selectedGroupCode={selectedGroupCode}
                isTableLoading={isTableLoading}
                setIsTableLoading={setIsTableLoading}
                sourceTables={sourceTables}
                selectedSourceTable={selectedSourceTable}
                setSelectedSourceTable={setSelectedSourceTable}
                selectedDestinationTable={selectedDestinationTable}
                sourceTableFields={sourceTableFields}
                unmappedFields={unmappedFields}
                setUnmappedFields={setUnmappedFields}
                fieldMappings={fieldMappings}
                editableFieldMappings={editableFieldMappings}
                setEditableFieldMappings={setEditableFieldMappings}
                setFieldMappings={setFieldMappings}
                setTriggerUpdate={setTriggerUpdate}
              />
            </DndProvider>
          </TabPane>
          <TabPane
            tab={t("Page.Operation.LegacyMapping.Tabs.MappingTemplates", {
              lngs: i18n.languages,
              defaultValue: "Mapping templates",
            })}
            key="mapping-templates"
          >
            <MappingTemplate
              mappingTemplates={mappingTemplates}
              setMappingTemplates={setMappingTemplates}
            />
          </TabPane>
        </Tabs>
      </div>
      <Drawer
        width={"400px"}
        title={t(
          "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionSaveAsTemplate",
          {
            lngs: i18n.languages,
            defaultValue: "Save as template",
          }
        )}
        placement="right"
        closable={false}
        visible={visibleDrawer === "1"}
        extra={
          <Space>
            <Button
              loading={saveMappingTemplateLoading}
              onClick={saveMappingTemplate}
              icon={<CheckOutlined />}
              size="small"
            >
              {t("General.Labels.Save", {
                lngs: i18n.languages,
                defaultValue: "Save",
              })}
            </Button>
            <Button
              type="ghost"
              loading={saveMappingTemplateLoading}
              onClick={onClose}
              icon={<CloseOutlined />}
              size="small"
            />
          </Space>
        }
      >
        <Radio.Group onChange={onRadioChange} value={mappingTemplateType}>
          <Radio value={1}>
            {t("Page.Operation.LegacyMapping.Tabs.Mapping.Labels.NewTemplate", {
              lngs: i18n.languages,
              defaultValue: "New template",
            })}
          </Radio>
          <Radio value={2}>
            {t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ExistingTemplate",
              {
                lngs: i18n.languages,
                defaultValue: "Existing template",
              }
            )}
          </Radio>
        </Radio.Group>

        {mappingTemplateType === 1 && (
          <Form name="drawer form" layout="vertical">
            <Form.Item
              label={t(
                "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.MappingTemplateName",
                {
                  lngs: i18n.languages,
                  defaultValue: "Mapping template name:",
                }
              )}
              tooltip={t(
                "Page.Operation.LegacyMapping.Tabs.Mapping.Tooltips.MappingTemplateName",
                {
                  lngs: i18n.languages,
                  defaultValue: "",
                }
              )}
              name="templateName"
              rules={[{ required: true, message: "Please input name" }]}
            >
              <Input
                placeholder={
                  t("General.Placeholders.EnterValue", {
                    lngs: i18n.languages,
                    defaultValue: "Enter value",
                  })!
                }
                maxLength={250}
                value={newMappingTemplateName}
                onChange={(e) => onMappingTemplateNameChange(e.target.value)}
              />
            </Form.Item>
          </Form>
        )}

        {mappingTemplateType === 2 && (
          <>
            <Form layout="vertical">
              <Form.Item
                label={t(
                  "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ChooseTemplate",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Choose template:",
                  }
                )}
                tooltip={t(
                  "Page.Operation.LegacyMapping.Tabs.Mapping.Tooltips.ChooseTemplate",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
                style={{ marginBottom: "0" }}
              >
                <Search
                  placeholder={
                    t(
                      "Page.Operation.LegacyMapping.Tabs.Mapping.Placeholders.SearchTemplate",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Search template",
                      }
                    )!
                  }
                  value={existingMappingTemplateSearchInput}
                  onChange={(e) =>
                    onExistingMappingTemplateSearch(e.target.value)
                  }
                />
              </Form.Item>
            </Form>
            <Menu
              className="templateMenu"
              onClick={handleExistingMappingTemplateChange}
              items={mappingTemplates
                .filter((x: any) =>
                  x.name
                    .toLowerCase()
                    .includes(existingMappingTemplateSearchInput.toLowerCase())
                )
                .map((item: any) => {
                  return {
                    key: item.id,
                    label: item.name,
                  };
                })}
            />
          </>
        )}
      </Drawer>
      <Drawer
        width={"400px"}
        title={t(
          "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ActionApplyTemplate",
          {
            lngs: i18n.languages,
            defaultValue: "Apply template",
          }
        )}
        placement="right"
        closable={false}
        visible={visibleDrawer === "2"}
        extra={
          <Space>
            <Button
              onClick={applyTemplate}
              icon={<CheckOutlined />}
              size="small"
            >
              {t("General.Labels.Apply", {
                lngs: i18n.languages,
                defaultValue: "Apply",
              })}
            </Button>
            <Button
              type="ghost"
              onClick={onClose}
              icon={<CloseOutlined />}
              size="small"
            />
          </Space>
        }
      >
        <Form layout="vertical">
          <Form.Item
            label={t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.ChooseTemplate",
              {
                lngs: i18n.languages,
                defaultValue: "Choose template:",
              }
            )}
            tooltip={t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Tooltips.ChooseTemplate",
              {
                lngs: i18n.languages,
                defaultValue: "",
              }
            )}
            style={{ marginBottom: "0" }}
          >
            <Search
              placeholder={
                t(
                  "Page.Operation.LegacyMapping.Tabs.Mapping.Placeholders.SearchTemplate",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Search template",
                  }
                )!
              }
              value={applyMappingTemplateSearchInput}
              onChange={(e) => onApplyMappingTemplateSearch(e.target.value)}
            />
          </Form.Item>
        </Form>
        <Menu
          className="templateMenu"
          onClick={handleApplyMappingTemplateChange}
          items={mappingTemplates
            .filter((x: any) =>
              x.name
                .toLowerCase()
                .includes(applyMappingTemplateSearchInput.toLowerCase())
            )
            .map((item: any) => {
              return {
                key: item.id,
                label: item.name,
              };
            })}
        />
      </Drawer>
      <Drawer
        width={"400px"}
        title={t(
          "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.AutomapWithAi",
          {
            lngs: i18n.languages,
            defaultValue: "Automap with Ai",
          }
        )}
        placement="right"
        closable={false}
        visible={isVisibleAutomapWithAiDrawer}
        extra={
          <Space>
            <Button
              type="primary"
              style={{ marginRight: "0.1px" }}
              className="automap-button"
              onClick={onAutoMapAiClick}
              icon={<img src="/ai.svg" />}
            >
              {t("Page.Operation.LegacyMapping.Tabs.Mapping.Labels.AutomapWithAi", {
                lngs: i18n.languages,
                defaultValue: "Automap with AI",
              })}
            </Button>
            <Button
              type="ghost"
              onClick={onCloseAutomapWithAiDrawer}
              icon={<CloseOutlined />}
              size="small"
            />
          </Space>
        }
      >
        <Form form={AutomapWithAiForm} layout="vertical">
          <Form.Item
            name="fromTableId"
            hidden>
          </Form.Item>
          <Form.Item
            name="toTableId"
            hidden>
          </Form.Item>
          <Form.Item
            name="entityId"
            hidden>
          </Form.Item>
          <Form.Item
            name="groupCode"
            hidden>
          </Form.Item>
          <Form.Item
            name="sourceErpId"
            label={t(
              "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.Entities.SourceSystem",
              { lngs: i18n.languages, defaultValue: "Source system:" }
            )}>
            <Select
              showSearch
              options={entitySystems.map((x: System) => ({
                label: x.name,
                value: x.id,
              }))}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              placeholder={t("General.Placeholders.SelectOption", {
                lngs: i18n.languages,
                defaultValue: "Select option",
              })!}
            />
          </Form.Item>
          <Form.Item
            name="targetErpId"
            label={t(
              "Page.Operation.LegacyMapping.Tabs.MappingLabels.Entities.TargetSystem",
              { lngs: i18n.languages, defaultValue: "Target system:" }
            )}>
            <Select
              showSearch
              options={entitySystems.map((x: System) => ({
                label: x.name,
                value: x.id,
              }))}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              placeholder={t("General.Placeholders.SelectOption", {
                lngs: i18n.languages,
                defaultValue: "Select option",
              })!}
            />
          </Form.Item>
          <h3> {t(
            "Page.Operation.LegacyMapping.Tabs.Mapping.Titles.Use data",
            { lngs: i18n.languages, defaultValue: "Include in AI Mapping Context" }
          )}</h3>
          <Form.Item
            className="checkbox">
            <Checkbox
              checked
              className="column-names-checkbox"
            >
              {t(
                "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.UseColumn",
                { lngs: i18n.languages, defaultValue: "Column names" }
              )}
            </Checkbox>
          </Form.Item>
          <Form.Item
            className="checkbox"
            name="useDescription"
            valuePropName="checked"
          >
            <Checkbox
            >
              {t(
                "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.UseDescription",
                { lngs: i18n.languages, defaultValue: "Column descriptions as defined in DATAshaper" }
              )}
            </Checkbox>
          </Form.Item>
          <Form.Item
            className="checkbox"
            name="useAiDescription"
            valuePropName="checked"
          >
            <Checkbox
            >
              {t(
                "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.UseAiDescription",
                { lngs: i18n.languages, defaultValue: "Column descriptions AI-generated" }
              )}
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="useSampleData"
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                "Page.Operation.LegacyMapping.Tabs.Mapping.Labels.UseSampleData",
                { lngs: i18n.languages, defaultValue: "Sample data" }
              )}
            </Checkbox>
          </Form.Item>
        </Form>
        <Alert message="This feature uses an AI agent to automatically generate suggested mappings for all unmapped fields, based on the information you provide.
          The proposed mappings will have the comment 'AI assisted mapping', making it easy for you to review, edit, or remove them as needed.
          Once you are satisfied and choose to save, these AI-generated mappings will be confirmed and added alongside your existing mappings" type="warning" />
      </Drawer>
    </div>
  );
};

export default LegacyMapping;
